module.exports = __webpack_public_path__ + "img/barIcon10.e11b12f8.png";